import Vue from 'vue'
import Layout from './components/Layout'
import Axios from 'axios'
import config from './config'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueRouter from 'vue-router'
import App from './App'
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/lib/css/mdb.min.css';
import router from './router';
import "@fortawesome/fontawesome-free/css/all.min.css";



Vue.config.productionTip = false

//const router = new VueRouter({ mode: 'history', routes }) //html5 history mode

//Vue.use(router)
Vue.use(VueRouter);
Vue.use(require('vue-moment'));


Vue.prototype.$axios = Axios;
Vue.prototype.$config = config;

Vue.filter("filterInt", function (value) {
  return Math.round(value);
});


//Vue.use(infiniteScroll)
Vue.use(VueSweetalert2);

Vue.component('Layout', Layout)


new Vue({
  config,
  router,
  render: h => h(App)
}).$mount('#app')
